import { Apple, Play } from "lucide-react";

/**
 * "Coming soon" App Store + Google Play badges.
 * Swap to real store URLs once published.
 */
export function StoreBadges({ className = "" }: { className?: string }) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {[
        { Icon: Apple, label: "Download on the", store: "App Store" },
        { Icon: Play, label: "Get it on", store: "Google Play" },
      ].map(({ Icon, label, store }) => (
        <button
          key={store}
          type="button"
          aria-label={`${store} — coming soon`}
          className="group relative flex items-center gap-3 rounded-2xl border border-foreground/15 bg-foreground/95 px-4 py-2.5 text-background shadow-lg transition-all hover:scale-[1.03] hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <Icon className="size-7 shrink-0" strokeWidth={1.5} aria-hidden="true" />
          <div className="text-left leading-tight">
            <p className="text-[10px] uppercase tracking-wider opacity-70">{label}</p>
            <p className="font-display-en text-base font-bold">{store}</p>
          </div>
          <span className="absolute -top-2 -right-2 rounded-full bg-primary px-2 py-0.5 text-[9px] font-black uppercase tracking-widest text-primary-foreground shadow-md">
            Soon
          </span>
        </button>
      ))}
    </div>
  );
}
